import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

class BackgroundActivities extends PureComponent {
  static propTypes = {
    profile: PropTypes.object.isRequired,
    unreadMessagesRequest: PropTypes.func.isRequired,
  }

  componentDidMount() {
    if (this.props.profile.id) {
      this.unreadMessageInterval = setInterval(() => {
        this.props.unreadMessagesRequest()
      }, 10000)
    }
  }

  componentDidUpdate() {
    clearInterval(this.unreadMessageInterval)

    if (this.props.profile.id) {
      this.unreadMessageInterval = setInterval(() => {
        this.props.unreadMessagesRequest()
      }, 10000)
    }
  }

  componentWillUnmount() {
    clearInterval(this.unreadMessageInterval)
  }

  render() {
    const { profile } = this.props // eslint-disable-line
    return <div />
  }
}

export default BackgroundActivities
